import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-calculation-page-resolver',
  templateUrl: 'calculation-page-resolver.html',
  encapsulation: ViewEncapsulation.None
})
export class CalculationPageResolverComponent {
  productType: string;

  constructor(
    private activatedRoute: ActivatedRoute,
  ) {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.productType = params.get('productType').toLowerCase();
    });
  }
}
